<template>
  <SelectWithSearch
    label="Item da lista de serviço do município"
    placeholder="Pesquise um NBS"
    v-model="input"
    :disabled="disabled"
    :clearable="clearable"
    :change="change"
    :options="nbsCollection"
    :filterBy="descriptionFilter"
    :error="error"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ formatOptions(props) }}</div>
    </template>
    <template slot="no-options"> Selecione um NBS </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.description }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectNBS',
  components: {
    SelectWithSearch,
  },
  mixins: [SearchMixin],
  props: {
    error: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setNbsCollection();
  },
  computed: {
    ...mapState('fiscalComponents', ['nbsCollection']),
  },
  methods: {
    ...mapActions('fiscalComponents', ['setNbsCollection']),

    change(value) {
      this.$emit('input', value);
    },
    formatOptions(props) {
      if (!props.data.id) return null;

      return `${props.data.code} - ${props.data.description}`;
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
